<template>
  <span
    class="flex-shrink-0 flex items-center justify-center rounded-sm transition-all"
    :class="size === 'sm' ? 'w-3 h-3' : 'w-3.5 h-3.5'"
    :style="checked
      ? { backgroundColor: color, borderColor: color,      borderWidth: '2px', borderStyle: 'solid' }
      : { backgroundColor: 'transparent', borderColor: color, borderWidth: '2px', borderStyle: 'solid' }"
  >
    <svg
      v-if="checked"
      viewBox="0 0 10 10"
      fill="none"
      stroke="white"
      :class="size === 'sm' ? 'w-2 h-2' : 'w-2.5 h-2.5'"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M1.5 5l2.5 2.5 4.5-4.5"/>
    </svg>
  </span>
</template>

<script setup>
defineProps({
  checked: { type: Boolean, required: true },
  color:   { type: String,  default: '#3b82f6' },
  size:    { type: String,  default: 'md' }, // 'md' | 'sm'
})
</script>
